export type User = {
  id: number;
  name: string;
  email: string;
  role: string;
  created_at: string;
};

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export async function fetchUsers(): Promise<User[]> {
  const response = await fetch(`${API_BASE_URL}/users`, {
    headers: {
      'x-user-role': 'admin',
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch users');
  }

  const body: { data: User[] } = await response.json();
  return body.data;
}

export async function createUser(payload: { name: string; email: string }): Promise<User> {
  const response = await fetch(`${API_BASE_URL}/users`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-user-role': 'admin',
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({ message: 'Failed to create user' }));
    throw new Error(errorBody.message || 'Failed to create user');
  }

  const body: { data: User } = await response.json();
  return body.data;
}
